import React from 'react';
import { Card, Icon, Button, Divider } from 'semantic-ui-react';
import _ from 'lodash';
import InfluencerShortlistCard from '../influencer-shortlist-card';
import ShortlistSummary from '../shortlist-summary';

const Shortlist = ({ shortlist, onApprove, onReject, onSubmit, linksMap, links }) => {
  const { influencers, organisation, isShortlistApprovalDisabled, selectedPlatforms } = shortlist;
  const influencerCount = _.size(influencers);
  const totalInstagram = _.sumBy(influencers, 'instagramCount');
  const totalYoutube = _.sumBy(influencers, 'youtubeCount');
  const totalFacebook = _.sumBy(influencers, 'facebookCount');
  const totalTwitter = _.sumBy(influencers, 'twitterCount');
  const totalTwitch = _.sumBy(influencers, 'twitchCount');
  const totalTiktok = _.sumBy(influencers, 'tiktokCount');

  return (
    <div>
      <Card fluid>
        <Card.Content header="Influencer shortlist" />

        <Card.Content description={shortlist.name} />

        <Card.Content extra>
          {
            _.map(shortlist.history, history => (
              <div>
                <Icon name="share" color="pink" />
                {history.message}
              </div>
            ))
          }
        </Card.Content>
      </Card>

      <Card fluid>
        <Card.Content header="Shortlist notes" />

        <Card.Content>
          <div dangerouslySetInnerHTML={{ __html: shortlist.notes }} />
        </Card.Content>
      </Card>

      <Divider hidden />
      <ShortlistSummary
        influencerCount={influencerCount}
        totalTwitter={totalTwitter}
        totalInstagram={totalInstagram}
        totalYoutube={totalYoutube}
        totalFacebook={totalFacebook}
        totalTwitch={totalTwitch}
        totalTiktok={totalTiktok}
        selectedPlatforms={selectedPlatforms}
      />
      <Divider hidden />

      <h2>Influencers</h2>


      <Card.Group itemsPerRow={3}>
        { _.map(shortlist.influencers, influencer => {
          const linkRecord = _.find(linksMap, { influencerId: influencer.id });
          let description;
          if (linkRecord) {
            const link = _.find(links, { id: linkRecord.linkId });
            description = link.influencerDetails.description;
          }
          return (
            <InfluencerShortlistCard
              key={influencer.id}
              influencer={influencer}
              selectedPlatforms={selectedPlatforms}
              organisation={organisation}
              description={description}
              dataNode={shortlist.dataMap[influencer.id]}
              isShortlistApprovalDisabled={isShortlistApprovalDisabled}
              onApprove={onApprove}
              onReject={onReject}
            />);
        }) }
      </Card.Group>

      <Divider />

      { !isShortlistApprovalDisabled && <Card fluid style={{ margin: '30px 0' }}>
        <Card.Content header="Finished your review?" />

        <Card.Content>
          <div style={{ textAlign: 'center' }}>
            { shortlist.status !== 'COMPLETED'
              ? <Button color="pink" content="submit feedback" floated="right" onClick={onSubmit} />
              : <h3>Thanks for your feedback <Icon name="thumbs up" color="pink" /></h3>
            }
          </div>
        </Card.Content>
      </Card> }

    </div>
  );
};

export default Shortlist;



// WEBPACK FOOTER //
// ./src/components/shortlist/index.js